import React from "react";
import HeaderSpacer from '../components/HeaderSpacer';
import styled from 'styled-components';
import {colours} from '../Styles';
import PDLineBreak from '../components/PDLineBreak';

function About() {
  const {accent, dark, light} = colours;
  const About = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    .about-content {
      width: 70%;
    }
    h1 {
      padding-top: 40px;
      text-align: center;
    }
    h2 {
      text-align: center;
    }
    h3, em, strong {
      color: ${accent};
    }
    p {
      margin-bottom: 20px;
      font-family: montserrat;
    }
    .dark-strip {
      width: 100%;
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      background: ${dark};
      p {
        width: 60%;
        color: ${light};
        font-size: 14px;
        margin-bottom: 0;
      }
    }
    @media only screen and (max-width: 600px) {
      .dark-strip {
        p {
          width: 90%;
        }
      }
      .about-content {
        width: 90%;
      }
    }
  `;
  return (
    <About>
    <HeaderSpacer/>
    <h1>About Us</h1>
      <div className="dark-strip">
        <p>
            Precision Detail is known for its meticulous detailing services
            along with a true customer service experience that leaves its
            clients coming back for more. Our technicians care for each car as
            if it were their own, and ensure that the customer is completely
            satisfied with the work performed while only using premium products.
            Each customer receives a full breakdown of the services they will
            receive and evaluate every car based on its needs – providing a true
            catered experience.
        </p>
      </div>
      <div className="about-content">
      <h2>The Process</h2>
        <h3>I. What is Car Detailing?</h3>
        <p>
          Simply put, getting your car detailed means a top-to-bottom thorough
          cleaning of your vehicle using specialized tools and products.
          Normally, a detailer will also perform some light cosmetic touch-ups,
          but the process does not include paintwork or body repairs.
          <br /><br />Car detailing involves cleaning and reconditioning the
          interior and exterior of the car. The aim of this is to restore the
          paintwork by eliminating scratches or swirl marks to make the car look
          almost brand new like it did when you first drove it out of the
          shop.<br /><br />
          A simple car wash gets rid of dirt on the outside of your car, and if
          you clean the interior you might catch some of the grime with a
          vacuum, but car detailing takes this process much further. Every car
          we detail has every last imperfection buffed, polished, or vacuumed
          out, leaving it fit for display in any showroom.<br /><br />
          Since there are no set guidelines, you will see a great variety in
          terms of the services included in a complete detail. At Precision
          Detail, our complete detail package consists of an exterior detailing
          using clay treatment and high-end wax, an advanced interior cleaning
          with stain removal and leather treatment as well as dressing on all
          the plastics.
        </p>
        <PDLineBreak colour={accent}/>
        <br/>
        <h3>II. What is the difference between Car Wash and an Auto Detail?</h3>
        <p>
          Now that you know what car detailing is, we are going to quickly
          outline the differences between a car wash and auto detailing, before
          going on to talk some more about why car detailing is a seriously good
          idea. <br /><br />
          Aside from cost, which ranges from $10 to $40, a typical car wash only
          covers a fraction of the cleaning that you can get from a detail, and
          so only achieves a fraction of the result. <br /><br />
          So what does a car wash include?
          <br /><br />
          Most car washes take between ten and twenty minutes to go from washing
          to drying. A car wash can be done by hand or by machines ( a drive
          thru car wash) that run bristles, soap, and water to clean your
          car&#39;s exterior.
          <br /><br />
          A car wash tends to be a superficial cleanse while an auto detail is
          more thorough and restorative.
        </p>
        <PDLineBreak colour={accent}/>
        <br/>
        <h3>III. What are the steps in Auto Detailing?</h3>
        <p>
          A thorough car detailing consists of two main phases: interior
          detailing and exterior detailing. We are going to break down each
          phase so you know exactly what to expect when you get your vehicle
          detailed.
          <br /><br />
          <em><strong>Exterior Car Detailing</strong></em>
          <br />
          We begin with an exhaustive exterior wash to remove as much dirt as
          possible. By allowing the soap to foam, dirt and mud are softened and
          lifted off the surface.
          <br /><br />
          Next, using special brushes and wheel cleaning products, the detailer
          takes off all the dust and filth from the wheels; brake calipers, lug
          nuts, etc. The wheels are usually the dirtiest parts of the car!
          <br /><br />
          After the wheels have been cleaned, the paintwork is washed and dried
          from top to bottom using washing mitts and soft microfiber towels. The
          paintwork is then clayed using automotive clay bar that removes the
          tightly bonded dirt of the surface of the car, which is your car&#39;s
          clear coat.
          <br /><br />
          If required, the paint is polished to eliminate any light scratches,
          oxidation, and swirl marks. The paint can be polished by hand or by a
          polishing machine. This can be the most time-consuming part of the
          detailing service depending on the car and the state of its paintwork.
          <br /><br />
          Finally, the paint is waxed to give it an additional protective layer
          using high-quality carnauba based paste wax. This added protection
          results in a noticeable shine too, the kind that you saw when you
          first bought it!
          <br /><br />
          The remaining exterior parts, like the windows and other rubber parts,
          are then polished and methodically cleaned, adding the finishing
          touches to all the corners of the car’s body and exterior trim to make
          the entire car sparkle.
          <br /><br />
          <em><strong>Interior Car Detailing</strong></em>
          <br />
          All of the upholstery inside the car is thoroughly vacuumed and
          shampooed to remove stains and dirt. If the car has leatherwork, this
          is often conditioned and scrubbed to remove dirt that is deeply
          ingrained. Plastics and vinyl are also properly cleaned and dressed.
          <br /><br />
          Lastly, the interior glass is also cleaned and polished.
          <br /><br />
          <em><strong>An Important Optional Step</strong></em>
          <br />
          Cleaning the engine bay is an important step but a lot of people
          simply don’t do it. The reason for this is probably that some people
          don’t care what their car looks like under the hood, or that they
          think only mechanics should venture to clean anywhere under there.
          <br /><br />
          However, there are steps you can take when you have your car detailed
          to protect some components from wear and tear. The detailer cleans the
          engine bay by lightly spraying it with water, and then wiping it down
          with a degreaser before rinsing everything clean. Once properly dried,
          all silicone, plastic and rubber components should be properly dressed
          to protect them from cracking. This is a simple process that
          ultimately serves to protect the car from everyday problems of wear on
          rubber and silicone.
        </p>
        <PDLineBreak colour={accent}/>
        <br/>
        <h3>IV. What are the benefits of getting your car detailed?</h3>
        <p>
          A complete car detail will bring your car to its best condition. You can then perform mini details
          to keep your car looking as good as new.
          <br/><br/>
          <em><strong>Car Value</strong></em>
          <br/>
          Keeping your car in good condition will help maintain or restore the value of your car. This is
          particularly true of older or classic cars, especially if you&#39;re looking to sell your car in the future.
          You simply cannot get the same results from car washes. A good detailer will bring your car to
          its original beauty and increase its resale value.
          <br/><br/>
          A good detailer will bring your car to its original beauty and increase its resale value. Having a
          regular exterior and interior detail can increase your car&#39;s resale value by 10-15%!
          <br/><br/>
          <em><strong>Protection</strong></em>
          <br/>
          Another benefit of auto detailing is the added protection against the elements. When a wax
          coat is routinely applied to the exterior painted surface, it protects the finish from
          contamination and oxidation (rust).
          <br/><br/>
          <em><strong>Attention to Detail</strong></em>
          <br/>
          Since detailing is an incredibly thorough process, you can expect the detailer to meticulously
          assess every crevice of your car to suggest customized solutions. You will not get this kind of
          personalized service at a car wash.
        </p>
        </div>
    </About>
  );
}

export default About;
